module.exports = __webpack_public_path__ + "static/img_9874-7bd251eb4e548877c5fddc156a8dec1e.webp";